import { render, staticRenderFns } from "./limitedDiscount.vue?vue&type=template&id=218c77d7"
import script from "./limitedDiscount.vue?vue&type=script&lang=js"
export * from "./limitedDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports